import React from 'react';
import { View } from '@react-pdf/renderer';

import PdfCropMark from '../atoms/PdfCropMark';

const PdfCropView = ({
  width, // Width in pts
  height, // Height in pts
  markLength, // Length in pts
}: {
  width: number;
  height: number;
  markLength: number;
}): JSX.Element => {
  return (
    <View
      style={{
        width,
        height,
        position: 'absolute',
      }}
    >
      <PdfCropMark orientation="horizontal" length={markLength} location="top-left"></PdfCropMark>
      <PdfCropMark orientation="vertical" length={markLength} location="top-left"></PdfCropMark>
      
      <PdfCropMark orientation="horizontal" length={markLength} location="top-right"></PdfCropMark>
      <PdfCropMark orientation="vertical" length={markLength} location="top-right"></PdfCropMark>
      
      <PdfCropMark orientation="horizontal" length={markLength} location="bottom-left"></PdfCropMark>
      <PdfCropMark orientation="vertical" length={markLength} location="bottom-left"></PdfCropMark>
      
      <PdfCropMark orientation="horizontal" length={markLength} location="bottom-right"></PdfCropMark>
      <PdfCropMark orientation="vertical" length={markLength} location="bottom-right"></PdfCropMark>
    </View>
  );
};

export default PdfCropView;
